module.exports = __webpack_public_path__ + "img/home-07-cosmopolitan-sample-04-street-06.69cb577c.jpg";